import { useAppSelector } from '@/store';
import { LoadingSpinner } from '@components/tailwind';
import ErrorBoundary from '@components/tailwind/ErrorBoundary';
import React, { Suspense } from 'react';
import { PDP_V2_ITEMS } from '@types';
import { lazyRetry } from '@utils/lazyRetry';

const ProductDimensions = React.lazy(() =>
  lazyRetry(
    () => import(/* webpackChunkName: "ProductDimensions" */ '@/components/ProductDimensions'),
    'ProductDimensions'
  )
);
const ProductComparison = React.lazy(() =>
  lazyRetry(
    () => import(/* webpackChunkName: "ProductComparison" */ '@/components/ProductComparison'),
    'ProductComparison'
  )
);

const Dimensions = () => {
  const { details, variants } = useAppSelector((state: any) => state.pdpItem);
  const isV2 = PDP_V2_ITEMS.includes(details?.attributes?.typeId);

  return (
    <>
      {details?.dimensionSpecs?.sizes ? (
        <ErrorBoundary>
          <Suspense
            fallback={
              <div className='tw:relative tw:h-20'>
                <LoadingSpinner small withContainer />
              </div>
            }>
            <ProductComparison
              activeAttribute={variants.activeSize}
              dimensionSpecs={details.dimensionSpecs}
              mode={isV2 ? 'v2' : 'v1'}
            />
          </Suspense>
        </ErrorBoundary>
      ) : (
        details?.webImages?.dimensions && (
          <ErrorBoundary>
            <Suspense
              fallback={
                <div className='tw:relative tw:h-20'>
                  <LoadingSpinner small withContainer />
                </div>
              }>
              <ProductDimensions
                dimensionSpecs={details.dimensionSpecs}
                dimensionImage={details.webImages.dimensions.active}
                displayName={details.displayName}
                position={isV2 ? 'bottom' : 'top'}
              />
            </Suspense>
          </ErrorBoundary>
        )
      )}
    </>
  );
};

export default Dimensions;
